export default __webpack_public_path__ + "static/media/Group824.18f7fb54.svg";